import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateCalendarTokenInputSchema, CalendarTokenResponseSchema, } from "@hourly/api/calendar";
const createCalendarToken = oc
    .route({
    method: "POST",
    path: "/calendar/tokens",
    summary: "Create a calendar token",
    tags: ["Calendar"],
    successStatus: 201,
})
    .input(CreateCalendarTokenInputSchema)
    .output(CalendarTokenResponseSchema);
const listCalendarTokens = oc
    .route({
    method: "GET",
    path: "/calendar/tokens",
    summary: "List user's calendar tokens",
    tags: ["Calendar"],
})
    .input(z.object({}))
    .output(z.array(CalendarTokenResponseSchema));
const revokeCalendarToken = oc
    .route({
    method: "DELETE",
    path: "/calendar/tokens/{id}",
    summary: "Revoke a calendar token",
    tags: ["Calendar"],
    successStatus: 204,
})
    .input(z.object({ id: z.uuid() }))
    .output(z.object({}));
export const calendarContract = {
    create: createCalendarToken,
    list: listCalendarTokens,
    revoke: revokeCalendarToken,
};
//# sourceMappingURL=calendar.js.map